import React from "react";
import Stack from "../../components/mui/Stack";
import Box from "../../components/mui/Box";
import { Controller } from "react-hook-form";
import Typography from "../../components/mui/Typography";
import FormControl from "../../components/mui/FormControl";
import TextField_new from "../../components/mui/TextField_new";

const EditParameterForm: React.FC<any> = (props) => {
  const { control, watch } = props;

  const parameterFormData = watch("parameterFormData");
  
  const calculateTotalPercentage = () => {
    return parameterFormData.reduce((acc: number, item: any, index: number) => {
      return acc + Number(item.percentage);
    }, 0);
  };

  return (
    <Stack>
      {parameterFormData.map((data: any, index: number) => (
        <Box key={index} sx={{ mb: "10px" }}>
          <Controller
            name={`parameterFormData.${index}.parameterTypeName`} // Include index in name
            control={control}
            rules={{ required: "Parameter name is required" }}
            render={({ field, fieldState: { error } }) => (
              <>
                <Typography>Parameter name</Typography>
                <FormControl error={!!error} fullWidth>
                  <TextField_new
                    size="small"
                    {...field}
                    disabled={true}
                    sx={{ width: "100%" }}
                    placeholder="Enter parameter name"
                    error={!!error}
                    helperText={error?.message || null}
                  />
                </FormControl>
              </>
            )}
          />
          <Controller
            name={`parameterFormData.${index}.percentage`} // Include index in name
            control={control}
            rules={{
              required: "Parameter Percentage is required",
              validate: (value) => {
                const total:number = calculateTotalPercentage();
                return total == 100 || "Total percentage must be 100%";
              },
            }}
            render={({ field, fieldState: { error } }) => (
              <>
                <Typography>Parameter Percentage <span style={{color:"red"}}> *</span></Typography>
                <FormControl error={!!error} fullWidth>
                  <TextField_new
                    size="small"
                    {...field}
                    sx={{ width: "100%" }}
                    placeholder="Enter parameter percentage"
                    endAdornment={<Typography variant="body2">%</Typography>}
                    error={!!error}
                    helperText={error?.message || null}
                  />
                </FormControl>
              </>
            )}
          />
          {index !== parameterFormData.length - 1 && (
            <Box sx={{ height: "1px", backgroundColor: "#997906" }}></Box>
          )}
        </Box>
      ))}
    </Stack>
  );
};

export default EditParameterForm;
